export const IMG = {
  logo: "/bb-logo.png",
  selfie:
    "https://customer-assets-jai6qajn.emergentagent.net/job_322e4ca0-c0f6-4f4a-92be-f850cf034ff2/artifacts/l7zl0wbs_6EE9B798-68AD-48A5-ADEB-C2F6448C5477_1_105_c.jpeg",
  spike:
    "https://customer-assets-jai6qajn.emergentagent.net/job_322e4ca0-c0f6-4f4a-92be-f850cf034ff2/artifacts/81iswouc_E54D564E-6921-44E9-BF9D-16FED6DD0DEC.webp",
  trophy:
    "https://customer-assets-jai6qajn.emergentagent.net/job_322e4ca0-c0f6-4f4a-92be-f850cf034ff2/artifacts/365auiws_30B9BDE7-C01B-4F0F-81FB-8A4BA3E87A74_1_105_c.jpeg",
  celebrate:
    "https://customer-assets-jai6qajn.emergentagent.net/job_322e4ca0-c0f6-4f4a-92be-f850cf034ff2/artifacts/5pckstkx_6DFD76DA-015E-416D-916A-D862AFE9AF29.webp",
};

export const LINKS = {
  instagram: "https://www.instagram.com/coach.tess.clinics/",
  instagramHandle: "@coach.tess.clinics",
  email: "coachtessclinics@gmail.com",
};
